<template lang="pug">
el-form-item(label-width="0")
  el-select.width-full(size="mini", v-model="data.content")
    el-option(v-for="{ columnDisplayName, columnName } in columns", :key="columnName", :value="columnName", :label="columnDisplayName")
</template>
<script>
import { baseMixin } from "./index.js";
export default {
  mixins: [baseMixin]
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
